import { Pipe, PipeTransform } from '@angular/core';
import { AttributeDefinition } from '../models/attributes/attributeDefinition';

@Pipe({
  name: 'customFieldTypeIcon',
})
export class CustomFieldTypeIconPipe implements PipeTransform {
  transform(attributeDef: AttributeDefinition): string {
    return attributeDef.getIcon();
  }
}
